import getStore from '../store/store';
import { mutator } from 'satcheljs';
import {
    clearLoadingScenarios,
    setLoadState,
    addLoadingScenario,
} from '../actions/internalActions';
import { getUserMailboxInfo } from 'owa-client-ids';
import { ObservableMap } from 'mobx';

mutator(addLoadingScenario, actionMessage => {
    getStore().calendarCacheInitializationState.calendarCacheInitializationLoadingScenarios.push(
        actionMessage.calendarCacheScenarioId
    );
});

mutator(clearLoadingScenarios, () => {
    getStore().calendarCacheInitializationState.calendarCacheInitializationLoadingScenarios = [];
});

mutator(setLoadState, actionMessage => {
    let mailboxId = actionMessage.mailboxId;
    if (!mailboxId) {
        // get default account's mailboxId
        mailboxId = getUserMailboxInfo().mailboxId;
    }

    const store = getStore();

    if (!store.calendarCacheInitializationState.calendarCacheInitializationLoadState) {
        store.calendarCacheInitializationState.calendarCacheInitializationLoadState = new ObservableMap();
    }
    store.calendarCacheInitializationState.calendarCacheInitializationLoadState.set(
        mailboxId,
        actionMessage.calendarCacheInitializationLoadState
    );
});
